import React, { Component } from 'react';

import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import config from '../../constants/GoogleMapsBasic';
import map from 'lodash/map';

const GOOGLE_API_KEY = config.key;

class FlightMap extends Component {
  constructor(props) {
    super(props);

    this.mapRef = React.createRef();
  }

  //Lifecycle
  mapLoaded(mapProps, map) {
    map.setOptions({ styles: config.mapStyle });

    this.defineBounds();
  }

  defineBounds() {
    const { airports } = this.props;

    const checkedAirports = airports.filter((airport) => airport);

    const bounds = new window.google.maps.LatLngBounds();
    map(checkedAirports, (airport) => {
      bounds.extend(
        new window.google.maps.LatLng(airport.latitude, airport.longitude)
      );

      return true;
    });

    this.mapRef.current?.map?.fitBounds(bounds);
  }

  filterMarker = (hotelId) => {
    this.props.toggleSelectedHotels(hotelId);
  };

  // Render
  render() {
    const { airports } = this.props;

    const checkedAirports = airports.filter((airport) => airport);

    return (
      <Map
        google={this.props.google}
        zoom={14}
        scrollwheel={false}
        keyboardShortcuts={false}
        disableDoubleClickZoom={true}
        zoomControl={false}
        mapTypeControl={false}
        scaleControl={false}
        streetViewControl={false}
        panControl={false}
        rotateControl={false}
        fullscreenControl={false}
        gestureHandling="none"
        disableDefaultUI={true}
        onReady={(mapProps, map) => this.mapLoaded(mapProps, map)}
        ref={this.mapRef}
      >
        {map(checkedAirports, (airport) => {
          return (
            <Marker
              key={`hotel-map-${airport.iata}`}
              position={{
                lat: airport.latitude,
                lng: airport.longitude,
              }}
              icon={{
                url: '/assets/img/icons/location_pin_selected.svg',
                scaledSize: new window.google.maps.Size(10, 10),
              }}
            />
          );
        })}
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: GOOGLE_API_KEY,
})(FlightMap);
